import { environment } from '../environments/environment';
var ɵ0 = environment;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
